import BaseSurvey from '@service-victoria/component-library/components/CompletionSurvey';
import React from 'react';

import { feedbackService } from 'app/services';
import { url, logger } from 'app/utils';
import { trackEvent } from 'app/utils/analytics';

type SurveyProps = {
  transactionID: string;
  transactionName: string;
};

const {
  CompletionSurvey: Survey,
  helpers: { getAnalyticsEvents }
} = BaseSurvey;

const events = getAnalyticsEvents('get-active-kids-apply');

const CompletionSurvey: React.FC<SurveyProps> = ({ transactionID, transactionName }) => {
  return (
    <Survey
      as='div'
      locale={{ prompt: 'How was your experience?' }}
      onThumbSelect={type => {
        trackEvent(type === 'up' ? events.thumbsUp : events.thumbsDown);
      }}
      onFeedbackGiven={async (type, message) => {
        trackEvent(events.submitFeedback);
        const baseUrl = url.getFeedbackApiDomain();
        try {
          await feedbackService.sendFeedback(
            baseUrl,
            type === 'up',
            message,
            transactionID,
            transactionName
          );
        } catch (error: any) {
          logger.error('Error recording feedback', error);
        }
      }}
      onSkip={() => trackEvent(events.skipFeedback)}
    />
  );
};

export default CompletionSurvey;
